var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8501 0.850006V4.85001C10.8501 5.38044 11.0608 5.88915 11.4359 6.26422C11.811 6.63929 12.3197 6.85001 12.8501 6.85001H16.8501M6.8501 7.85001H4.8501M12.8501 11.85H4.8501M12.8501 15.85H4.8501M11.8501 0.850006H2.8501C2.31966 0.850006 1.81096 1.06072 1.43588 1.43579C1.06081 1.81087 0.850098 2.31957 0.850098 2.85001V18.85C0.850098 19.3804 1.06081 19.8891 1.43588 20.2642C1.81096 20.6393 2.31966 20.85 2.8501 20.85H14.8501C15.3805 20.85 15.8892 20.6393 16.2643 20.2642C16.6394 19.8891 16.8501 19.3804 16.8501 18.85V5.85001L11.8501 0.850006Z",
    stroke: "#565D6D",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsIcon);
export default __webpack_public_path__ + "static/media/docs-icon.5b442579dd502d2dfa04c845ee18aa2e.svg";
export { ForwardRef as ReactComponent };